import { useLocation } from '@tanstack/react-router';

/**
 * The URL on screen as typed: its path, query string and fragment, without the origin. Only for passing a URL on
 * unchanged, such as a full-page app's path, which `params` would decode and encode again. Read a param with
 * `Route.useParams()`, and tell which page is on screen with `useRouteName()` or `useIsRouteActive()`.
 */
export function useLocationHref(): string {
    return useLocation({ select: (location) => location.href });
}
